<template>
    <div>
        <div class="app-title">
            <div>
                <h2>{{$t('tlt.prd.downtimePlanList')}}</h2>
                <ul class="app-breadcrumb breadcrumb">
                    <li class="breadcrumb-item"><router-link to="/"><i class="fa fa-home"></i></router-link></li>
                    <!-- <li class="breadcrumb-item"><router-link to="/prd"><span>{{$t('tlt.production')}}</span></router-link></li> -->
                    <li class="breadcrumb-item"><router-link to="/prd/downtimePlan"><span>{{$t('tlt.downtimePlan')}}</span></router-link></li>
                </ul>
            </div>                       
            <div class="col-lg-2">
                <div class="float-lg-right">
                    <button class="btn btn-outline-primary" v-on:click="MMFNew('downtimePlan')">
                        <i class="fa fa-fw fa-lg fa-plus"></i>
                        <span class="text">{{ $t("btn.basic.add") }}</span>
                    </button>
                </div>
            </div>
        </div>
        <section class="app-content">
           <div id="accordionFilter" class="content">
                <div class="card">
                    <div
                        id="collapseOne"
                        class="collapse show "
                        aria-labelledby="headingOne"
                        data-parent="#accordionFilter"
                        >
                        <div class="card-body">
                            <form class="row" id="form" >
                                <div class="form-group col-md-2">
                                        <label class="control-label"><span class="lbl-required"></span>{{$t('lbl.downtimePlan.locName')}}:</label>
                                        <input class="form-control" type="text" v-model="locNameFilter">
                                </div>
                                <div class="form-group col-md-2">
                                    <label class="control-label"><span class="lbl-obg"></span>{{$t('lbl.downtimePlan.startDate')}}：</label>
                                    <mmf-datepicker      v-model="startDateFilter"></mmf-datepicker>                                                     
                                </div>
                                <div class="form-group col-md-2">
                                    <label class="control-label"><span class="lbl-obg"></span>{{$t('lbl.downtimePlan.endDate')}}：</label>
                                    <mmf-datepicker      v-model="endDateFilter"></mmf-datepicker>
                                </div>                       
                                <div class="col align-self-end">
                                    <div class="float-lg-right">
                                        <button class="btn btn-outline-secondary mr-1" type="button" v-on:click="MMFClearFilter('downtimePlan')"><i class="fa fa-fw fa-lg fa-eraser"></i><span class=text>{{$t('btn.basic.clear')}}</span></button>
                                        <button class="btn btn-primary" type="button" v-on:click="MMFLoadRows('downtimePlan')"><i class="fa fa-fw fa-lg fa-search"></i><span class=text>{{$t('btn.basic.search')}}</span></button>
                                    </div>                                                        
                                </div>  
                            </form>
                        </div>
                     </div>   
                </div>
            </div>
            <div id="downtimePlanResultTable" class="content">
                <div class="card my-1">
                    <div
                        id="collapseTwo"
                        class="collapse show"
                        aria-labelledby="headingTwo"
                        data-parent="#accordionResult"
                        >
                        <div class="card-body">
                            <mmf-table  entity="downtimePlan"
                                        inline-actions-disabled :singleChoice='true'>
                            </mmf-table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { createHelpers } from 'vuex-map-fields';
import {gridFields, filterFields}  from "@/model/prd/productionPlan/DowntimePlan";
import MmfTable from "@/components/MmfTable";
import MmfDatepicker from '@/components/MmfDatepicker';

// create a helper to generate getters and setters with namespace
const { mapFields } = createHelpers({
    getterType: 'downtimePlan/getField',
    mutationType: 'downtimePlan/updateField',
});

export default {
  name: "downtimePlanList",
  data () {
    return {
    //   checkedItems: []
    }
  },
  components: { MmfTable, MmfDatepicker},
  computed: {
        // generate and add getters and setters using the filter names defined in
        // entity model
        ...mapFields(filterFields),
        ...mapState({
            rows: state => state.downtimePlan.rows,
            checkedItems: state => state.downtimePlan.checkedItems,
            showNoResultAlert: state => state.base.showNoResultAlert,
            tableColumns: gridFields
        })
  },
  methods: {
    ...mapActions("base", ["MMFselectRow", "MMFselectAllRows", "MMFNew", 
    "MMFEdit", "MMFLoadRows", "MMFDelete", "MMFClearFilter"])
  },
  mounted(){
  }
};
</script>
